import {
  createBookmarkType,
  doExportAviInterface,
  getStreamNameType,
  initBookmarkType,
  initBrowseInterface
} from './ocularis/types';
import ocularisService, { OcularisServiceData } from './ocularis/ocularisService';
import cayugaService, { CayugaServiceData } from './cayuga/cayugaService';
import { serviceTypeEnum, tokenType } from '../store/API/types';
import { IAdapterGetTimeLine, IAdapterGoto, IAdapterMoveSequence, IAdapterMoveStep, loginType } from './types';
import { createCayugaBookmarkType } from "./cayuga/types";
import { isPresentObject } from "../types";

const setService = () => {
  switch (window.CONFIG.ServerType) {
    case serviceTypeEnum.ocularis:
      return new ServiceAdapter({type: 1, ocularis: ocularisService});
    case serviceTypeEnum.cayuga:
      return new ServiceAdapter({type: 2, cayuga: cayugaService});
    default:
      return new ServiceAdapter({type: 1, ocularis: ocularisService});
  }
}

export type ApiType = | { type: serviceTypeEnum.ocularis, ocularis: OcularisServiceData }
  | { type: serviceTypeEnum.cayuga, cayuga: CayugaServiceData };

export class ServiceAdapter {
  constructor(private api: ApiType) {
  }

  // common methods
  login = ({username, password, cancelId}: loginType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.login({username, password, cancelId});
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.login({username, password, cancelId});
    }
  }
  checkConnection = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.checkConnection(token);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.checkConnection(token);
    }
  }
  getCameraList = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getCameraList(token);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.getCameraList(token);
    }
  }
  getLayouts = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getLayouts(token);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestEntityTree(token);
    }
  }
  getAlarmsList = (token: tokenType, transactionId?: any) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.pollEvents(token, transactionId);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestAlarmScenarioList(token);
    }
  }
  getTimeLine = ({token, pane, startTime, endTime, continuationId, camId}: IAdapterGetTimeLine) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        if ((pane !== undefined) && startTime && endTime && typeof (continuationId) !== 'undefined') {
          return this.api.ocularis.getTimeLine({token, pane, startTime, endTime, continuationId});
        }
        break;
      case serviceTypeEnum.cayuga:
        if (camId) {
          return this.api.cayuga.getTimeLine({token, camId});
        }
        break;
    }
  }
  getBookmarks = (token: tokenType, camId?: string, startTimestamp?: number, stopTimestamp?: number, keywords?: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getBookmarks(token);
      case serviceTypeEnum.cayuga:
        if (camId) {
          return this.api.cayuga.getBookmarks(token, camId, startTimestamp, stopTimestamp, keywords);
        }
    }
  }
  generateId = () => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.generateId();
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.generateId();
    }
  }
  getStreamName = (options: getStreamNameType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getStreamName(options);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  cancelAllRequests = () => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.cancelAllRequests();
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.cancelAllRequests();
    }
  }
  cancelRequest = (id: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.cancelRequest(id);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.cancelRequest(id);
    }
  }
  clearId = (id: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.clearId(id);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.clearId(id);
    }
  }
  browseGoto = (params: IAdapterGoto) => {
    const {token, time, pane, id, dir, camId, width} = params;
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.browseGoto({token, pane, time, id, dir});

      case serviceTypeEnum.cayuga:
        return this.api.cayuga.browseGoto({token, pane, id, time, camId, width});
    }
  }
  browseMoveStep = (params: IAdapterMoveStep) => {
    const {token, pane, id, cb, dir, camId, width, time} = params;
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        if (dir === 1) {
          return this.api.ocularis.browseMoveNext({token, pane, id, cb});
        } else if (dir === -1) {
          return this.api.ocularis.browseMovePrev({token, pane, id, cb});
        }
        break;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.browseMoveStep({token, pane, id, time, camId, width, dir, cb});
    }
  }
  browsePrevSequence = (params: IAdapterMoveSequence) => {
    const {token, pane, id, time, cb} = params;
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.browsePrevSequence({token, pane, id, time, cb});
      case serviceTypeEnum.cayuga:
        break;
    }
  }
  browseNextSequence = (params: IAdapterMoveSequence) => {
    const {token, pane, id, time, cb} = params;
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.browseNextSequence({token, pane, id, time, cb});
      case serviceTypeEnum.cayuga:
        break;
    }
  }
  globalTrigger = (token: tokenType, triggerId: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.globalTrigger(token, triggerId);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.startButtonAction(token, triggerId);
    }
  }
  createBookmark = (params: createBookmarkType | createCayugaBookmarkType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        if (isPresentObject<createBookmarkType>(params)) {
          return this.api.ocularis.createBookmark(params);
        }
        break;
      case serviceTypeEnum.cayuga:
        if (isPresentObject<createCayugaBookmarkType>(params)) {
          return this.api.cayuga.setBookmark(params);
        }
        break;
    }
  }
  deleteBookmark = (token: tokenType, id: string | number) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.deleteBookmark(token, typeof id === 'number' ? id : -1);
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.deleteBookmark(token, typeof id === 'string' ? id : '');
    }
  }

  // ocularis methods
  duoLogin = (token: tokenType, sigResponse: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.duoLogin(token, sigResponse);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  doPaneHeartBeat = (token: tokenType, pane: number) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.doPaneHeartBeat(token, pane);
      case serviceTypeEnum.cayuga:
        break;
    }
  }
  disconnectPane = (token: tokenType, pane: number) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.disconnectPane(token, pane);
      case serviceTypeEnum.cayuga:
        break;
    }
  }
  initBrowse = (params: initBrowseInterface) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.initBrowse(params);
      case serviceTypeEnum.cayuga:
        break;
    }
  }
  startBrowse = (token: tokenType, pane: number) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.startBrowse(token, pane);
      case serviceTypeEnum.cayuga:
        break;
    }
  };
  initBookmark = (params: initBookmarkType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.initBookmark(params);
      case serviceTypeEnum.cayuga:
        break;
    }
  }
  deviceStatus = (token: tokenType, id: string, pane: number) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.deviceStatus(token, id, pane);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  getPrivilledges = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getPrivilledges(token);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  getCapibilities = (token: tokenType, pane: number) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getCapibilities(token, pane);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  getPresets = (token: tokenType, pane: number) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getPresets(token, pane);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  getEventsInfo = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getEventsInfo(token);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  getBkmsInfo = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getBkmsInfo(token);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  doExportAvi = (params: doExportAviInterface) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.doExportAvi(params);
      case serviceTypeEnum.cayuga:
        return null;
    }
  }
  getBkmThumbnailSrc = (thumbnailUrl: string, token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return this.api.ocularis.getBkmThumbnailSrc(thumbnailUrl, token);
      case serviceTypeEnum.cayuga:
        return '';
    }
  }

  // cayuga methods
  getDetailedCameraList = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.getDetailedCameraList(token);
    }
  }
  requestButtonList = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestButtonList(token);
    }
  }
  requestLayerInfo = (token: tokenType, layerId: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestLayerInfo(token, layerId);
    }
  }
  requestMapInfo = (token: tokenType, mapId: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestMapInfo(token, mapId);
    }
  }
  requestWebPageInfo = (token: tokenType, webPageId: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestWebPageInfo(token, webPageId);
    }
  }
  requestNewAlarm = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestNewAlarm(token);
    }
  }
  requestScenarioList = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestAlarmScenarioList(token);
    }
  }
  requestVersionInfo = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.requestVersionInfo(token);
    }
  }
  confirmAlarm = (token: tokenType, alarmID: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.confirmAlarm(token, alarmID);
    }
  }
  refuseAlarm = (token: tokenType, alarmID: string) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.refuseAlarm(token, alarmID);
    }
  }
  searchTriggeredAlarms = (token: tokenType, startTime: number, endTime: number, alarmScenarioIDs: Array<string>) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.searchTriggeredAlarms(token, startTime, endTime, alarmScenarioIDs);
    }
  }
  disconnect = (token: tokenType) => {
    switch (this.api.type) {
      case serviceTypeEnum.ocularis:
        return null;
      case serviceTypeEnum.cayuga:
        return this.api.cayuga.disconnect(token);
    }
  }

}

const adapter = setService();

export default adapter;